<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      >
      </mat-paginator>

      <mat-form-field appearance="outline" class="bisual-paginator-select">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="scopes">
          <mat-option value="activeWorkers">Activos</mat-option>
          <mat-option value="workers">Todos</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <input matInput type="text" formControlName="search" />
        <button matSuffix mat-icon-button aria-label="Clear">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="profile-pic">
          <th mat-header-cell *matHeaderCellDef></th>
          <td class="profile-pic" mat-cell *matCellDef="let user">
            @if (user.profile_picture_url != null) {
              <img [ngSrc]="user.profile_picture_url" alt="profile-pic" width="25" height="25" />
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="serious-pic">
          <th mat-header-cell *matHeaderCellDef></th>
          <td class="profile-pic" mat-cell *matCellDef="let user">
            @if (user.serious_profile_image_url != null) {
              <img [ngSrc]="user.serious_profile_image_url" alt="serious-pic" width="25" height="25" />
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let user">
            <a [routerLink]="['/employees', 'direction', 'users', user.id]">{{ user.full_name }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let user">
            {{ user.email }}
          </td>
        </ng-container>

        <ng-container matColumnDef="company_products">
          <th mat-header-cell *matHeaderCellDef>Productos</th>
          <td class="profile-pic" mat-cell *matCellDef="let user">
            @for (company_product of user.active_company_products; track $index) {
              @if (company_product.logo_url != null) {
                <img
                  [ngSrc]="company_product.logo_url"
                  [alt]="company_product.id"
                  [matTooltip]="company_product.title"
                  width="25"
                  height="25"
                />
              }
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="homeOfficeDay">
          <th mat-header-cell *matHeaderCellDef>Día Teletrabajo</th>
          <td mat-cell *matCellDef="let user">
            {{ user | remoteWorkDays }}
          </td>
        </ng-container>

        <ng-container matColumnDef="hollidays">
          <th mat-header-cell *matHeaderCellDef>Vacaciones</th>
          <td mat-cell *matCellDef="let user">
            @if (user.current_working_contract && user.vacation_days_with_pending) {
              <div class="progress">
                <div
                  class="vacation-days-spent"
                  [style.width]="user.vacation_days_with_pending.spent.percentage + '%'"
                  [matTooltip]="'Concedidas: ' + user.vacation_days_with_pending.spent.days"
                ></div>
                <div
                  class="vacation-days-pending"
                  [style.width]="user.vacation_days_with_pending.pending.percentage + '%'"
                  [matTooltip]="'Pendientes: ' + user.vacation_days_with_pending.pending.days"
                ></div>
                <div
                  class="vacation-days-left"
                  [style.width]="user.vacation_days_with_pending.left.percentage + '%'"
                  [matTooltip]="'Por pedir: ' + user.vacation_days_with_pending.left.days"
                ></div>
              </div>
            }
          </td>

          <td></td
        ></ng-container>

        <ng-container matColumnDef="categories">
          <th mat-header-cell *matHeaderCellDef>Categorias</th>
          <td mat-cell *matCellDef="let user">
            @if (user.current_working_contract) {
              <ul>
                @for (
                  category of user.current_working_contract.current_working_contract_variable_condition.department_categories;
                  track $index
                ) {
                  <li>{{ category.name }}</li>
                }
              </ul>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let user; let i = index">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                [routerLink]="['/employees', 'direction', 'users', user.id]"
                [disabled]="!permissions.validateDepartment(['direction', 'rrhh'])"
              >
                <mat-icon matPrefix>edit</mat-icon>
                Editar usuario
              </button>
              @if (me.id != user.id) {
                <button mat-menu-item (click)="impersonateUser(i)" [disabled]="!permissions.validateDepartment(['direction'])">
                  <mat-icon matPrefix>person</mat-icon>
                  Impersonar usuario
                </button>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
